import React from 'react';
import { withLocalize, Translate } from "react-localize-redux";
import Number from '../common/numberComponent';

import Section from '../common/section';

class IndustryRegionData extends React.Component {
    constructor(props) {
        super(props);

        this.state = { rOpen: false, iOpen: false };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state.rOpen !== nextState.rOpen || this.state.iOpen !== nextState.iOpen;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        return (
            <div id="industry-region-root">
                {this.renderIndustry(data.industry, data.short, data.desc, data.industryTotalFormated)}
                {this.renderRegion(data.region, data.short, data.desc, data.regionTotalFormated)}
            </div>
        )
    }

    renderIndustry = (industry, short, desc, total) => {
        return (
            <React.Fragment>
                <Section isOpen={this.state.iOpen} name={this.props.translate("Report.IndustryRegion.Subject")} >
                    <SectionSummaryTable short={short} desc={desc} total={total}></SectionSummaryTable>
                    <br />
                    <table className="table table-report-section-2">
                        <thead>
                            <tr>
                                <th><Translate id="Report.IndustryRegion.IndustryHeader"></Translate></th>
                                <th><Translate id="Report.IndustryRegion.TotalRevenues"></Translate></th>
                                <th><Translate id="Report.IndustryRegion.Share"></Translate></th>
                            </tr>
                        </thead>
                        <SectionTableBody items={industry} total={total} />
                    </table>
                </Section>
            </React.Fragment>
        )
    }

    renderRegion = (region, short, desc, total) => {
        return (
            <div id="region-root">
                <Section isOpen={this.state.rOpen} name={this.props.translate('Report.IndustryRegion.RegionInfo')} >
                    <SectionSummaryTable short={short} desc={desc} total={total}></SectionSummaryTable>
                    <br />
                    <table className="table table-report-section-2">
                        <thead>
                            <tr>
                                <th><Translate id="Report.IndustryRegion.RevenueList"></Translate></th>
                                <th><Translate id="Report.IndustryRegion.TotalRevenues"></Translate></th>
                                <th><Translate id="Report.IndustryRegion.Share"></Translate></th>
                            </tr>
                        </thead>
                        <SectionTableBody items={region} total={total} ></SectionTableBody>
                    </table>
                </Section>
            </div>
        )
    }
}

const SectionSummaryTable = (props) => {
    return (
        <table className="table table-report-section">
            <tbody>
                <tr>
                    <td style={{ width: "15%" }}><Translate id="Report.IndustryRegion.Nace"/></td>
                    <td style={{ width: "85%" }}>{props.short} - {props.desc}</td>
                </tr>
                <tr>
                    <td><Translate id="Report.IndustryRegion.TotalRevenues"/></td>
                    <td>{props.total}</td>
                </tr>
            </tbody>
        </table>
    )
}

const SectionTableBody = (props) => {
    return (
        <tbody>
            {props.items.map((item, i) => {
                return (<tr key={i}>
                    <td>{i === 9 ? <Translate id="Report.Common.Others"/> : item.name}</td>
                    <td>{item.turnoverFormated}</td>
                    <td>{item.shareFormated}</td>
                </tr>)
            })}
            <tr style={{ fontWeight: '600', borderTop: '1px solid black' }}>
                <td><Translate id="Report.IndustryRegion.Summary"/></td>
                <td>{props.total}</td>
                <td><Number value={100} fixed={true} /></td>
            </tr>
        </tbody>
    )
}

export default withLocalize(IndustryRegionData);